module.exports = __webpack_public_path__ + "static/img/作品103.1b09771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品103.png
// module id = wzGo
// module chunks = 1